/**
 * Environment detection utilities
 */

export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};

export const isTest = (): boolean => {
  return process.env.NODE_ENV === 'test';
};

export const isDevelopmentOrTest = (): boolean => {
  const env = process.env.NODE_ENV;
  return env === 'development' || env === 'test';
};